// =============================================================================
// lib/format.ts — shared number + crypto-identity formatting helpers for CRYB.
// =============================================================================
import { Platform, TextStyle } from 'react-native';

// Apply to any Text that shows a live-updating number so digits don't reflow
// as values tick (lining + tabular figures).
export const tabularNums: TextStyle = { fontVariant: ['tabular-nums'] };

// Monospace treatment for crypto-native tokens: wallet addresses, tx hashes,
// contract addresses, tickers, seed-word slots. Reads as "on-chain data".
export const mono: TextStyle = {
  fontFamily: Platform.select({ ios: 'Menlo', android: 'monospace', default: 'monospace' }),
};

/**
 * Truncate a wallet/contract address or tx hash the crypto-native way:
 * 0x1234abcd…9f8e7d60. Keeps the checksum-recognizable head + tail.
 */
export function truncateAddress(addr?: string | null, head = 6, tail = 4): string {
  if (!addr || typeof addr !== 'string') return '';
  const a = addr.trim();
  if (a.length <= head + tail + 1) return a;
  return `${a.slice(0, head)}…${a.slice(-tail)}`;
}

/** Ensure a symbol reads as a ticker: uppercase, optional $ prefix ($BTC). */
export function ticker(symbol?: string | null, withDollar = true): string {
  if (!symbol) return '';
  const s = symbol.trim().toUpperCase().replace(/^\$+/, '');
  return withDollar ? `$${s}` : s;
}
